var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-light justify-content-center justify-content-md-start pr-0"},[_c('div',[_c('Logo',{staticClass:"mt-4 ml-0 ml-md-5"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }